import { css } from '@emotion/react';

import { campaignManagerTheme } from '@campaign-manager/theme';

export const trixEditorWrapper = css`
  /* Override Trix default styles to match app design */

/* Reset Trix toolbar structure */
trix-toolbar * {
  box-sizing: border-box !important;
}

/* Main toolbar container */
trix-toolbar {
  background-color: #f5f5f5 !important;
  border: none !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-radius: 8px 8px 0 0 !important;
  padding: 8px !important;
  margin: 0 !important;
}

/* Button row layout */
trix-toolbar .trix-button-row {
  display: flex !important;
  flex-wrap: nowrap !important;
  justify-content: flex-start !important;
  overflow-x: auto !important;
  align-items: center !important;
  gap: 8px !important;
}

/* Button groups */
trix-toolbar .trix-button-group {
  display: flex !important;
  margin: 0 !important;
  margin-bottom: 0 !important;
  border: none !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  border-radius: 6px !important;
  background-color: white !important;
  overflow: hidden !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
}

trix-toolbar .trix-button-group:not(:first-child) {
  margin-left: 0 !important;
}

@media (max-width: 768px) {
  trix-toolbar .trix-button-group:not(:first-child) {
    margin-left: 0 !important;
  }
}

/* Button group spacer */
trix-toolbar .trix-button-group-spacer {
  flex-grow: 1 !important;
}

@media (max-width: 768px) {
  trix-toolbar .trix-button-group-spacer {
    display: none !important;
  }
}

/* Individual buttons */
trix-toolbar .trix-button {
  position: relative !important;
  float: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: rgba(0, 0, 0, 0.6) !important;
  font-size: 0.75em !important;
  font-weight: 400 !important;
  white-space: nowrap !important;
  padding: 6px 10px !important;
  margin: 0 !important;
  outline: none !important;
  border: none !important;
  border-bottom: none !important;
  border-left: none !important;
  border-radius: 0 !important;
  background: transparent !important;
  cursor: pointer !important;
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1) !important;
  min-width: 32px !important;
  height: 32px !important;
}

/* Button separators */
trix-toolbar .trix-button:not(:first-child) {
  border-left: 1px solid rgba(0, 0, 0, 0.08) !important;
}

/* Active button state */
trix-toolbar .trix-button.trix-active {
  background: oklch(from ${campaignManagerTheme.color.secondary} calc(l + 0.575) 0.020 h) !important;
  color: white !important;
}

/* Button not disabled cursor */
trix-toolbar .trix-button:not(:disabled) {
  cursor: pointer !important;
}

/* Button hover state */
trix-toolbar .trix-button:not(:disabled):hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

trix-toolbar .trix-button.trix-active:hover {
  background: oklch(from ${campaignManagerTheme.color.secondary} calc(l + 0.575) 0.020 h) !important;
  color: white !important;
}

/* Disabled state */
trix-toolbar .trix-button:disabled {
  color: rgba(0, 0, 0, 0.3) !important;
  opacity: 0.4 !important;
  cursor: not-allowed !important;
}

@media (max-width: 768px) {
  trix-toolbar .trix-button {
    letter-spacing: -0.01em !important;
    padding: 6px 8px !important;
  }
}

/* Icon buttons */
trix-toolbar .trix-button--icon {
  font-size: inherit !important;
  width: 32px !important;
  height: 32px !important;
  max-width: 32px !important;
  text-indent: -9999px !important;
  padding: 6px !important;
}

@media (max-width: 768px) {
  trix-toolbar .trix-button--icon {
    height: 32px !important;
    width: 28px !important;
    max-width: 28px !important;
  }
}

/* Button icons - Fix icon visibility */
trix-toolbar .trix-button--icon::before {
  display: inline-block !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  opacity: 1 !important;
  font-size: 16px !important;
  line-height: 1 !important;
  width: 16px !important;
  height: 16px !important;
  background-size: 16px 16px !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  margin: 0 !important;
  text-indent: 0 !important;
}

/* Custom HTML source button */
trix-toolbar .trix-button-html-source {
  position: relative !important;
  float: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: rgba(0, 0, 0, 0.6) !important;
  font-family: monospace !important;
  font-size: 10px !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  padding: 6px 10px !important;
  margin: 0 !important;
  outline: none !important;
  border: none !important;
  border-bottom: none !important;
  background: transparent !important;
  cursor: pointer !important;
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1) !important;
  min-width: 32px !important;
  height: 32px !important;
  text-indent: 0 !important;
}

trix-toolbar .trix-button-html-source:not(:first-child) {
  border-left: 1px solid rgba(0, 0, 0, 0.08) !important;
}

trix-toolbar .trix-button-html-source:not(:disabled):hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

/* Dialogs (like link input) */
trix-toolbar .trix-dialog {
  border-radius: 8px !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  background: white !important;
  padding: 12px !important;
  position: absolute !important;
  top: 100% !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 1000 !important;
  margin-top: 4px !important;
}

trix-toolbar .trix-dialog__link-fields {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
}

trix-toolbar .trix-dialog input[type="url"] {
  border-radius: 6px !important;
  border: 1px solid rgba(0, 0, 0, 0.23) !important;
  padding: 8px 12px !important;
  font-size: 14px !important;
  font-family: inherit !important;
  background: white !important;
  color: rgba(0, 0, 0, 0.87) !important;
  flex: 1 !important;
}

trix-toolbar .trix-dialog input[type="url"]:focus {
  outline: none !important;
  border-color: ${campaignManagerTheme.color.secondary} !important;
  border-width: 2px !important;
  padding: 7px 11px !important;
}

trix-toolbar .trix-dialog .trix-button {
  border-radius: 6px !important;
  padding: 6px 16px !important;
  font-size: 14px !important;
  text-transform: none !important;
  background: oklch(from ${campaignManagerTheme.color.secondary} calc(l + 0.575) 0.020 h) !important;
  color: white !important;
  border: none !important;
  min-width: 64px !important;
  height: auto !important;
  text-indent: 0 !important;
}

trix-toolbar .trix-dialog .trix-button:hover {
  background: oklch(from ${campaignManagerTheme.color.secondary} calc(l + 0.575) 0.020 h) !important;
}

/* Editor content area */
trix-editor {
  background-color: white !important;
  border: none !important;
  border-radius: 0 0 8px 8px !important;
  margin: 0 !important;
  padding: 12px !important;
  font-size: 14px !important;
  line-height: 1.6 !important;
  color: rgba(0, 0, 0, 0.87) !important;
  outline: none !important;
  min-height: 80px !important;
}

/* Placeholder text */
trix-editor:empty::before {
  color: rgba(0, 0, 0, 0.38) !important;
  font-size: 14px !important;
}

/* Content element styles */
trix-editor ul,
trix-editor ol {
  margin: 8px 0 !important;
  padding-left: 24px !important;
}

trix-editor li {
  margin-bottom: 4px !important;
}

trix-editor blockquote {
  border-left: 3px solid rgba(0, 0, 0, 0.12) !important;
  margin: 8px 0 !important;
  padding-left: 16px !important;
  font-style: italic !important;
  color: rgba(0, 0, 0, 0.6) !important;
}

trix-editor pre {
  background-color: #f5f5f5 !important;
  border-radius: 6px !important;
  padding: 12px !important;
  font-family: monospace !important;
  font-size: 13px !important;
  overflow: auto !important;
  margin: 8px 0 !important;
}

trix-editor code {
  background-color: #f5f5f5 !important;
  border-radius: 3px !important;
  padding: 2px 4px !important;
  font-family: monospace !important;
  font-size: 0.875em !important;
}

trix-editor a {
  background: oklch(from ${campaignManagerTheme.color.secondary} calc(l + 0.575) 0.020 h) !important;
  text-decoration: underline !important;
}

trix-editor a:hover {
  text-decoration: none !important;
}

/* Headings */
trix-editor h1 {
  font-size: 24px !important;
  font-weight: 600 !important;
  margin: 16px 0 8px 0 !important;
}

trix-editor h2 {
  font-size: 20px !important;
  font-weight: 600 !important;
  margin: 14px 0 6px 0 !important;
}

trix-editor h3 {
  font-size: 18px !important;
  font-weight: 600 !important;
  margin: 12px 0 4px 0 !important;
}

/* Remove default attachment styles */
trix-editor .attachment {
  display: none !important;
}

/* Custom button group for source tools */
trix-toolbar .trix-button-group--source-tools {
  display: flex !important;
  margin: 0 !important;
  margin-bottom: 0 !important;
  border: none !important;
  border-radius: 6px !important;
  background-color: white !important;
  overflow: hidden !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
}
`;

export const errorState = css`
  border-color: #d32f2f !important;
  
  &:hover {
    border-color: #d32f2f !important;
  }
  
  &:focus-within {
    border-color: #d32f2f !important;
  }
`;
